import { Flex, Text } from '@chakra-ui/react';
import { Inbox } from 'lucide-react';

export function EmptyTicketList() {
  return (
    <Flex
      direction="column"
      justify="center"
      align="center"
      h="100%"
      gap="4"
      color="fg.muted"
      py="12"
    >
      <Inbox size={64} strokeWidth={1.5} />
      <Text fontSize="md" fontWeight="medium">
        No support requests
      </Text>
    </Flex>
  );
}
